// extracted by mini-css-extract-plugin
module.exports = {"root":"move-module--root--35uBU","content":"move-module--content--KnTSr","spacer":"move-module--spacer--20Duy"};